<template>
  <div class="container">
    <PublicHeader :totalName="$t('forgotPass').title" />
    <!-- 输入框 -->
    <div class="content">
      <!-- 切换 -->
      <div class="tabs">
        <span :class="regType == 'Email' ? 'active' : ''" @click="regType = 'Email'" v-if="loginTypeArr.includes('Email')">{{ $t('register').Mailbox }}</span>
        <span :class="regType == 'Phone' ? 'active' : ''" @click="regType = 'Phone'" v-if="loginTypeArr.includes('Phone')">{{ $t('register').PhoneNumber
          }}</span>
      </div>
      <!-- 电子邮箱-->
      <div class="item" v-if="regType == 'Email'">
        <van-field v-model="Email" :placeholder="$t('register').placeholder5"></van-field>
      </div>
      <!-- 手机号-->
      <div class="item" v-if="regType == 'Phone'">
        <van-field v-model="PhoneNumber" type="tel" :placeholder="$t('register').placeholder0">
          <template #left-icon>
            <VueCountryIntl schema="popover" v-model="PhoneNumberCode" :listZIndex="10000" popoverClass="selectCountry" :searchInputPlaceholder="$t('register').searchCountryMsg" @onChange="selectCountry">
              <i class="select_btn" slot="reference" @click="selectCountry">
                <span> +{{ PhoneNumberCode }}</span>
                <van-icon name="play" size="13" class="ric" color="var(--text_color)" />
                <div class="line"></div>
              </i>
            </VueCountryIntl>
          </template>
        </van-field>
      </div>
      <!-- 验证码 -->
      <div class="item">
        <van-field v-model="Captcha" :placeholder="$t('register').placeholder4">
          <template #right-icon>
            <span style="color: var(--primary_color)" @click="getCaptchaCode" v-if="countDownSec === 60">{{ tips
            }}</span>
            <span v-else style="color: var(--ntext_color)">{{ countDownSec }} s</span>
          </template>
        </van-field>
      </div>
      <!-- 密码 -->
      <div class="item">
        <van-field v-model="password" :type="psdType" :placeholder="$t('forgotPass').Password" :right-icon="psdType === 'password' ? 'eye' : 'closed-eye'" @click-right-icon="psdType = psdType === 'password' ? 'text' : 'password'">
        </van-field>
      </div>
      <!-- 确认密码 -->
      <div class="item">
        <van-field v-model="twoPassword" :type="twopsdType" :placeholder="$t('register').ConfirmPassword" :right-icon="twopsdType === 'password' ? 'eye' : 'closed-eye'" @click-right-icon="twopsdType = twopsdType === 'password' ? 'text' : 'password'">
        </van-field>
      </div>
      <!-- 按钮 -->
      <van-button block @click="handleSub">{{ $t('forgotPass').btn }}</van-button>
    </div>
  </div>
</template>

<script>
import userApi from '@/api/user'
import systemApi from '@/api/system'
import PublicHeader from '@/components/publicHeader'

export default {
  components: {
    PublicHeader
  },
  data() {
    return {
      loginTypeArr: [],//支持的登录方式
      regType: 'Email',
      PhoneNumberCode: '1', //手机区号
      PhoneNumber: '', //手机号
      Email: '',//邮箱
      Captcha: '', //验证码
      uuid: '',//验证码token
      password: '',//密码
      twoPassword: '',//确认密码
      psdType: "password", //输入框类型
      twopsdType: "password", //输入框类型
      tips: this.$t('register').send,//发送验证码信息
      countDownSec: 60,
      timer: null,
    }
  },
  mounted() {
    this.getConfig()
  },
  methods: {
    // 获取配置
    async getConfig() {
      const res = await systemApi.getConfig()
      if (res.systemSetting.loginType) {
        this.loginTypeArr = res.systemSetting.loginType
        this.regType = this.loginTypeArr[0]
      }
    },
    // 选择国家区号
    selectCountry() {
      this.$nextTick(() => {
        const searchInput = document.querySelector(
          '.selectCountry .search-input'
        )
        if (searchInput) {
          searchInput.style.width = '90%'
          searchInput.style.height = 'auto'
        }
      })
    },
    //获取验证码
    async getCaptchaCode() {
      if (this.timer) return
      // 手机号注册
      if (this.regType == 'Phone') {
        if (this.PhoneNumber == '') {
          this.$toast({
            message: this.$t('register').placeholder0,
            position: 'center'
          })
          return
        }
      }
      // 邮箱注册
      if (this.regType == 'Email') {
        if (!this.Email) {
          this.$toast(this.$t('register').placeholder5)
          return false
        }
        const reg = new RegExp(
          '^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,}$'
        )
        if (!reg.test(this.Email.toLowerCase())) {
          this.$toast(this.$t('register').emaiError)
          return false
        }
      }
      this.sendCode()
    },
    //发送验证码
    async sendCode() {
      this.countDownSec--
      this.timer = setInterval(() => {
        this.countDownSec--
        if (this.countDownSec === 0) {
          this.countDownSec = 60
          this.tips = this.$t('register').Resend
          clearInterval(this.timer)
          this.timer = null
        }
      }, 1000)
      const pRes = await userApi.sendCode({
        type: this.regType,
        phoneNumberCode: '+' + this.PhoneNumberCode,
        phoneNumber: this.PhoneNumber,
        email: this.Email
      })
      this.$toast({ message: this.$t('register').sendSuccess })
      this.uuid = pRes.uuid
    },
    // 提交注册
    async handleSub() {
      if (!this.checkForm()) return
      const form = {
        type: this.regType,
        phoneNumber: this.PhoneNumber,
        phoneNumberCode: '+' + this.PhoneNumberCode,
        email: this.Email,
        uuid: this.uuid,
        captcha: this.Captcha,
        passWord: this.password,
      }
      await userApi.forgetPassword(form)
      this.$toast(this.$t('forgotPass').success)
      setTimeout(() => {
        this.$router.push({ name: 'Login' })
      }, 1000)
    },
    // 表单验证
    checkForm() {
      // 手机号
      if (this.regType == 'Phone') {
        if (!this.PhoneNumber) {
          this.$toast({
            message: this.$t('register').placeholder0,
            position: 'center'
          })
          return false
        }
      }
      // 邮箱
      if (this.regType == 'Email') {
        if (!this.Email) {
          this.$toast({
            message: this.$t('register').placeholder5,
            position: 'center'
          })
          return false
        }
      }
      // 验证码
      if (!this.Captcha) {
        this.$toast({
          message: this.$t('register').placeholder4,
          position: 'center'
        })
        return false
      }
      // 密码
      if (this.password.length < 6) {
        this.$toast({
          message: this.$t('forgotPass').placeholder,
          position: 'center'
        })
        return false
      }
      if (this.twoPassword.length < 6) {
        this.$toast({
          message: this.$t('register').message1,
          position: 'center'
        })
        return false
      }
      if (this.password != this.twoPassword) {
        this.$toast({
          message: this.$t('register').message2,
          position: 'center'
        })
        return false
      }
      return true
    }
  }
}
</script>

<style lang="less" scoped>
.container {
  min-height: 100vh;
  width: 100%;
  padding: 15px;
  background: var(--background_color);

  .content {
    .tabs {
      margin: 60px 0 20px 0;
      font-weight: bold;
      font-size: 14px;
      color: var(--ntext_color);

      span {
        margin-right: 20px;
      }

      .active {
        color: var(--primary_color);
      }
    }

    .item {
      margin-top: 15px;

      .select_btn {
        font-size: 14px;
        color: var(--text_color);
        margin-right: 10px;
        display: flex;
        align-items: center;

        .ric {
          transform: rotate(90deg);
          margin: 0 10px 0 5px;
        }

        .line {
          height: 15px;
          background: var(--ntext_color);
          width: 1px;
        }
      }
    }

    .van-button {
      margin-top: 30px;
      background: var(--primary_color);
      height: 40px;
      border-radius: 20px;
      border: 0;
      font-size: 15px;
      color: #fff;
    }

    .footer {
      position: fixed;
      bottom: 30px;
      font-size: 12px;
      color: var(--ntext_color);

      span {
        color: var(--text_color);
        font-weight: bold;
      }
    }
  }
}

::v-deep .van-field__value {
  overflow: visible;
  display: grid;
}

::v-deep .van-cell {
  background: var(--background_color);
  padding: 0 10px;
  height: 40px;
  margin-bottom: 10px;
  border-radius: 10px;
  font-size: 14px;
  border: 1px solid var(--info_color);
}

::v-deep .van-field__control {
  color: var(--text_color);
}

::v-deep .van-field__control::-webkit-input-placeholder {
  color: var(--ntext_color);
  font-size: 14px;
  opacity: 0.9;
}

::v-deep .van-field__left-icon {
  align-items: center;
  display: flex;
}

::v-deep .van-tab {
  font-size: 15px;
  justify-content: left;
}

::v-deep .van-tab--active {
  font-weight: bold;
}

::v-deep .van-checkbox__label {
  margin-left: 5px;
  color: var(--text_color);
  font-size: 14px;
}
</style>
